import { render, staticRenderFns } from "./goldenSentenceS.vue?vue&type=template&id=b1d0d9e8&scoped=true&"
import script from "./goldenSentenceS.vue?vue&type=script&lang=js&"
export * from "./goldenSentenceS.vue?vue&type=script&lang=js&"
import style0 from "./goldenSentenceS.vue?vue&type=style&index=0&id=b1d0d9e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d0d9e8",
  null
  
)

export default component.exports